export const BUSINESS = {
  name: "Crawford Construction & Development Ltd.",
  shortName: "Crawford Construction",
  address: "Placencia Village, Stann Creek District, Belize",
  phone: "+501-639-5057",
  phoneHref: "tel:+5016395057",
  email: "contact@crawfordconstruction.bz",
  years: "12+",
  tagline: "Building Belize's Coastline, One Landmark at a Time",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    key: "residential-commercial",
    title: "Residential & Commercial Construction",
    desc: "Full-scope building for private homes, vacation rentals, and commercial developments delivered on time and on budget.",
    icon: "Building2",
  },
  {
    key: "concrete-wooden-homes",
    title: "Concrete & Wooden Homes",
    desc: "Durable reinforced-concrete and beautifully crafted wooden homes engineered for the Belizean climate.",
    icon: "Home",
  },
  {
    key: "waterfront-structures",
    title: "Waterfront Structures",
    desc: "Coastal builds designed to withstand tides, storms and salt — combining resilience with striking design.",
    icon: "Waves",
  },
  {
    key: "docks-piers-seawalls",
    title: "Docks, Piers & Seawalls",
    desc: "Custom docks, piers and seawalls with reinforced foundations built for lasting protection and access.",
    icon: "Anchor",
  },
  {
    key: "retaining-walls",
    title: "Retaining Walls",
    desc: "Engineered retaining walls that stabilize land, prevent erosion and unlock difficult terrain.",
    icon: "BrickWall",
  },
  {
    key: "land-development",
    title: "Land Development Projects",
    desc: "Site clearing, grading and infrastructure preparation to turn raw land into build-ready property.",
    icon: "Trees",
  },
  {
    key: "custom-solutions",
    title: "Custom Construction Solutions",
    desc: "Tailored construction solutions engineered around your vision, site and budget.",
    icon: "Ruler",
  },
];
